import { loadGLTF } from '../../Reusable/loadGLTF'

export class CityItems {
  static cache = new Map()
  constructor () {
    this.rawfiles = require('./glb/glb.js').default
    this.meshfiles = require('./mesh/glb.js').default
    this.types = []
    this.list = []
    this.special = [
      {
        isLand: true,
        name: '_dill8l26f'
      }
    ]
    for (let smkn in this.rawfiles) {
      let arr = smkn.split('___TYPE___')
      let type = arr[0]
      let name = arr[1]
      let isSpecial = this.special.map(e => e.name).includes(name)
      let meta = this.special.find(e => e.name === name) || {}
      this.list.push({
        ...meta,
        key: smkn,
        type,
        name,
        special: isSpecial,
        url: this.rawfiles[smkn],
      })
      // console.log(name)
      if (!this.types.includes(type)) {
        this.types.push(type)
      }
    }
    for (let smkn in this.meshfiles) {
      let arr = smkn.split('___TYPE___')
      let type = arr[0]
      let name = arr[1]
      let isSpecial = this.special.map(e => e.name).includes(name)
      let meta = this.special.find(e => e.name === name) || {}
      this.list.push({
        ...meta,
        key: smkn,
        type,
        name,
        special: isSpecial,
        url: this.meshfiles[smkn],
      })
      // console.log(name)
      if (!this.types.includes(type)) {
        this.types.push(type)
      }
    }
  }
  static async cacheLoadGLTF ({ url }) {
    if (CityItems.cache.has(url)) {
      return CityItems.cache.get(url)
    }
    let gltf = await loadGLTF(url)
    CityItems.cache.set(url, gltf)
    return gltf
  }

  static async loadGLTF ({ url }) {
    let gltf = await loadGLTF(url)
    return gltf
  }

  static async preloadByName ({ name }) {
    let found = this.lib.find(e => e.key === name)
    let gltf = await CityItems.cacheLoadGLTF({ url: found.url })
    return gltf
  }
}
